import { render, staticRenderFns } from "./representative-form.vue?vue&type=template&id=02bd7466&"
import script from "./representative-form.vue?vue&type=script&lang=js&"
export * from "./representative-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports